import { Hooks } from 'providers';
import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import DeleteImg from 'assets/img/delete_img.png';

import { HIT_BOARD_STATUS, HIT_LIST_MEMBER_BOARD } from 'redux/actions/board';
import { HIT_LIST_MEMBER } from 'redux/actions/company';
import { POP_UP } from 'redux/actions/loading';
import { apiDeleteBoardMember } from 'redux/api/board';
import { apiDeleteCompanyMember } from 'redux/api/company';
import { useTranslation } from 'react-i18next';

function DeleteBoard() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    setModalDeleteMember, modalDeleteMember, setModal, text,
  } = useContext(Hooks);

  const DeleteMember_ = async () => {
    try {
      const response = await apiDeleteCompanyMember({
        company_id: text.company_id,
        member_id: text.id,
      });
      dispatch({
        type: POP_UP,
        payload: {
          status: 'success',
          message: response.message,
        },
      });
      dispatch({
        type: HIT_LIST_MEMBER,
      });
    } catch (error) {
      dispatch({
        type: POP_UP,
        payload: {
          status: 'failed',
          message: 'Failed delete company member!',
        },
      });
    }
  };

  const handleDeleteMember = async () => {
    try {
      if (text.isAdmin) {
        dispatch({
          type: HIT_BOARD_STATUS,
          payload: {
            status: 'failed',
            message: 'The Feature on Development',
          },
        });
      } else {
        await apiDeleteBoardMember({
          board_id: text.board_id,
          member_id: text.id,
        });
        dispatch({
          type: POP_UP,
          payload: {
            status: 'success',
            message: 'Success delete company member!',
          },
        });
        dispatch({
          type: HIT_LIST_MEMBER_BOARD,
          payload: {
            board_id: text.board_id,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: POP_UP,
        payload: {
          status: 'failed',
          message: 'Failed delete company member!',
        },
      });
    }
  };

  useEffect(() => { }, [modalDeleteMember]);

  return (
    <div
      className={`modal fade rModal ${modalDeleteMember && 'show'}`}
      id="deleteModal"
      tabIndex={-1}
      role="dialog"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-sm"
        role="document"
        style={{
          boxShadow: '0px 10px 15px 7px rgba(0,0,0,0.1)',
        }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t('general.message.del_member')}</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setModalDeleteMember(false);
                setModal(false);
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body m-3">
            <img src={DeleteImg} alt="delete.jpg" className="rModalImg" />
            <p className="mb-0">{`${t('general.message.del_member')} ${text.name}?`}</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              onClick={() => {
                setModalDeleteMember(false);
                setModal(false);
              }}
            >
              {t('biz_process.cancel')}
            </button>
            <button
              onClick={() => {
                if (text.company_id === undefined) {
                  handleDeleteMember();
                } else {
                  DeleteMember_();
                }
                setModalDeleteMember(false);
                setModal(false);
              }}
              type="button"
              data-dismiss="modal"
              className="btn btn-primary"
            >
              {t('workload_landing.continue')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteBoard;
